import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-share-modal",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-overlay" *ngIf="isOpen" (click)="close()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h3>Partager le live</h3>
          <button class="close-btn" (click)="close()">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <!-- Boutons de partage réseaux sociaux -->
          <div class="share-buttons">
            <button class="share-btn whatsapp" (click)="shareOn('whatsapp')">
              <i class="fab fa-whatsapp"></i>
              <span>WhatsApp</span>
            </button>
            <button class="share-btn facebook" (click)="shareOn('facebook')">
              <i class="fab fa-facebook-f"></i>
              <span>Facebook</span>
            </button>
            <button class="share-btn twitter" (click)="shareOn('twitter')">
              <i class="fab fa-twitter"></i>
              <span>Twitter</span>
            </button>
            <button class="share-btn linkedin" (click)="shareOn('linkedin')">
              <i class="fab fa-linkedin-in"></i>
              <span>LinkedIn</span>
            </button>
            <button class="share-btn telegram" (click)="shareOn('telegram')">
              <i class="fab fa-telegram-plane"></i>
              <span>Telegram</span>
            </button>
          </div>

          <!-- Copier le lien -->
          <div class="copy-link-section">
            <div class="link-input-wrapper">
              <input
                type="text"
                [value]="shareUrl"
                readonly
                class="link-input"
                #linkInput
              />
              <button
                class="copy-btn"
                (click)="copyLink(linkInput)"
                [class.copied]="isCopied"
              >
                <i
                  class="fas"
                  [class.fa-check]="isCopied"
                  [class.fa-copy]="!isCopied"
                ></i>
                {{ isCopied ? "Copié" : "Copier" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        padding: 20px;
      }

      .modal-content {
        background: white;
        border-radius: 12px;
        width: 100%;
        max-width: 500px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
        animation: slideUp 0.3s ease;
      }

      @keyframes slideUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid #eee;
      }

      .modal-header h3 {
        margin: 0;
        font-size: 20px;
        color: #333;
      }

      .close-btn {
        background: none;
        border: none;
        font-size: 20px;
        color: #666;
        cursor: pointer;
        padding: 5px;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
      }

      .close-btn:hover {
        background: #f0f0f0;
        color: #333;
      }

      .modal-body {
        padding: 20px;
      }

      .share-buttons {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        gap: 12px;
        margin-bottom: 20px;
      }

      .share-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        padding: 16px 12px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s;
        font-size: 14px;
        color: white;
      }

      .share-btn i {
        font-size: 24px;
      }

      .share-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      .share-btn.whatsapp {
        background: #25d366;
      }

      .share-btn.facebook {
        background: #1877f2;
      }

      .share-btn.twitter {
        background: #1da1f2;
      }

      .share-btn.linkedin {
        background: #0a66c2;
      }

      .share-btn.telegram {
        background: #0088cc;
      }

      .copy-link-section {
        padding-top: 20px;
        border-top: 1px solid #eee;
      }

      .link-input-wrapper {
        display: flex;
        gap: 10px;
        align-items: center;
      }

      .link-input {
        flex: 1;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 8px;
        font-size: 14px;
        color: #666;
        background: #f8f9fa;
      }

      .copy-btn {
        padding: 12px 20px;
        background: #dc3545;
        color: white;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 8px;
        transition: all 0.2s;
        white-space: nowrap;
      }

      .copy-btn:hover {
        background: #c82333;
      }

      .copy-btn.copied {
        background: #28a745;
      }

      @media (max-width: 768px) {
        .modal-content {
          max-width: 100%;
          margin: 0 10px;
        }

        .share-buttons {
          grid-template-columns: repeat(3, 1fr);
        }

        .link-input-wrapper {
          flex-direction: column;
        }

        .copy-btn {
          width: 100%;
          justify-content: center;
        }
      }
    `,
  ],
})
export class ShareModalComponent {
  @Input() isOpen: boolean = false;
  @Input() shareUrl: string = "";
  @Input() title: string = "Regardez ce live !";
  @Output() closeModal = new EventEmitter<void>();

  isCopied: boolean = false;

  close() {
    this.closeModal.emit();
  }

  shareOn(platform: string) {
    const encodedUrl = encodeURIComponent(this.shareUrl);
    const encodedTitle = encodeURIComponent(this.title);
    let shareLink = "";

    switch (platform) {
      case "whatsapp":
        shareLink = `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`;
        break;
      case "facebook":
        shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case "twitter":
        shareLink = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
        break;
      case "linkedin":
        shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
      case "telegram":
        shareLink = `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`;
        break;
    }

    if (shareLink) {
      window.open(shareLink, "_blank", "width=600,height=400");
    }
  }

  copyLink(input: HTMLInputElement) {
    input.select();
    document.execCommand("copy");
    this.isCopied = true;

    setTimeout(() => {
      this.isCopied = false;
    }, 2000);
  }
}
